import React from "react";

export default function MobileCallBar() {
  const PHONE_E164 = "+4917641011065";     // mit +
  const WHATSAPP_NUMBER = "4917641011065"; // ohne +

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-white/95 backdrop-blur border-t">
      <div className="max-w-[1100px] mx-auto px-4 py-2 grid grid-cols-2 gap-3">
        
        {/* Anrufen */}
        <a
          href={`tel:${PHONE_E164}`}
          className="rounded-xl px-4 py-3 font-semibold bg-[#FF6B00] text-white text-center"
        >
          📞 Anrufen
        </a>

        {/* WhatsApp */}
        <a
          href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
            "Hallo, ich möchte einen Umzug anfragen."
          )}`}
          target="_blank"
          rel="noreferrer"
          className="rounded-xl px-4 py-3 font-semibold border border-slate-300 text-center"
        >
          💬 WhatsApp
        </a>

      </div>

      {/* Spacer: verhindert Überdeckung von Inhalt */}
      <div className="h-[8px]" />
    </div>
  );
}
